'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { AuthQueryOptions } from '@/api';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

//* 통합 게이트 예외 경로 — 이 경로들에선 강제 이동하지 않는다.
const ALLOWED_PATHS = ['/account-integration', '/login', '/easy-certification'];

/**
 * 로그인 회원에게 동일인 통합 대상 계정이 있으면 계정통합 화면으로 강제 이동시키는
 * 블로킹 게이트. 통합이 끝나기 전에는 다른 작업을 할 수 없다.
 */
export const AccountIntegrationController = () => {
  const $ = _c(10);
  const pathname = usePathname();
  const router = useCustomRouter();
  const isLogin = useAuthStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthQueryOptions["get:/wello/v3/auth/account-integration/candidates"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isLogin === true;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: _temp2
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: hasCandidates
  } = useQuery(t2);
  let t3;
  if ($[3] !== pathname) {
    t3 = pathname ? ALLOWED_PATHS.some(path => pathname.startsWith(path)) : true;
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isAllowedPath = t3;
  let t4;
  let t5;
  if ($[5] !== hasCandidates || $[6] !== isAllowedPath || $[7] !== router) {
    t4 = () => {
      if (!hasCandidates || isAllowedPath) {
        return;
      }
      router.replace(ROUTES.ACCOUNT_INTEGRATION.pathname);
    };
    t5 = [hasCandidates, isAllowedPath, router];
    $[5] = hasCandidates;
    $[6] = isAllowedPath;
    $[7] = router;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  return null;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(t0) {
  const {
    context
  } = t0;
  return (context?.totalCount ?? 0) > 0;
}